(function() {
    'use strict';

const TR = angular.module('TR');
TR.directive('similarHotels', SimilarHotels);

function SimilarHotels(hotelService) {
    return {
        restrict: 'E',
        scope: {
            hotel: '=',
            similarHotelsLoader: '=',
            showSimilarHotels: '='
        },
        templateUrl: 'partials/home/directivetemplate?type=SimilarHotelGrid',
        link($scope, $element) {
            $scope.similarHotels = {};

            async function getSimilarHotelsInfo({ Id }) {
                try {
                    const SimilarHotels = await hotelService.getSimilarHotels(Id);
                    const elem = $element[0];

                    if (!SimilarHotels.length) {
                        elem.classList.add('u-hidden');
                    }

                    if (!SimilarHotels.length) { return; }

                    $scope.showSimilarHotels = true;
                    $scope.similarHotelsLoader = false;
                    const similarHotels = SimilarHotels.map(hotel => {
                        const SubTitle = `${hotel.Province}, ${hotel.Location}`;
                        const AltText = `${hotel.Title}, ${SubTitle}, ${hotel.Country}`;
                        const TitleText = `${hotel.Title}, ${SubTitle}, ${hotel.Country}`;
                        const AriaLabel = `${hotel.Title}, ${SubTitle}, ${hotel.Country}`;
                        const ImgSrcUrl = `https://hi-cdn.t-rp.co.uk/images/hotels/${hotel.Id}/0?width=400&amp;height=225&amp;crop=true`;
                        return { ...hotel, SubTitle, AriaLabel, AltText, TitleText, ImgSrcUrl };
                    });

                    $scope.similarHotels = similarHotels;

                } catch (err) {
                    $scope.showSimilarHotels = false;
                    $scope.similarHotelsLoader = false;
                    console.log('Similar Hotel details not fetched.');
                    console.log(err);
                }
            }

            getSimilarHotelsInfo($scope.hotel);
        }

    };
}

})();

